"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createClient = void 0;

var _feature = require("../feature");

// TODO: Just adding comment in here
var createClient = (options, dispatcher) => {
  var handleCreateFeature = (featureType, featureOptions) => {
    return (0, _feature.getFeature)(featureType, featureOptions, options, dispatcher);
  };

  return {
    create: handleCreateFeature
  };
};

exports.createClient = createClient;